import { Injectable } from '@angular/core';
import { IFRAME_EVENT_NAME } from '../../models/consts/Other.const';
import { StateService } from '../state/state.service';
import { BehaviorSubject } from 'rxjs';
import { EnvUtils } from '../../commons/utils/env.utils';

interface IframeEnableEvent {
  key: string; // Secret Key to enable iframe mode
  token: string; // Bearer token
  urlNames: string[]; // list of urlName of salon should be display on iframe mode
}

@Injectable({
  providedIn: 'root',
})
export class IframeService {
  private iframeModeEnabled$$ = new BehaviorSubject<boolean>(false);
  public readonly iframeModeEnabled$ = this.iframeModeEnabled$$.asObservable();

  private urlNames: string[];

  constructor(private stateService: StateService) {}

  public async init() {
    if (!this.isInIframe()) {
      return;
    }

    const listener = (e) => {
      try {
        const event = JSON.parse(e?.data);

        if (
          !this.iframeModeEnabled$$.value &&
          event?.type === IFRAME_EVENT_NAME.ENABLE_IFRAME_MODE
        ) {
          const data: IframeEnableEvent = event?.data;

          const iframeModeKeyToStore: string = data?.key;
          const token: string = data?.token;
          const urlNamesToStore: string[] = data?.urlNames;

          const iframeModeEnabled =
            iframeModeKeyToStore === EnvUtils.getIframeModeKey() &&
            urlNamesToStore?.length > 0;
          if (iframeModeEnabled) {
            this.stateService.setToken(token);
            this.urlNames = urlNamesToStore || [];

            this.iframeModeEnabled$$.next(true);

            window.removeEventListener('message', listener);
          }
        }
      } catch (e) {}
    };

    window.addEventListener('message', listener);

    // tell parent to send ENABLE_IFRAME_MODE event
    this.emitEnableIframeModeRequiredEvent();
  }

  public isInIframe(): boolean {
    try {
      return window.self !== window.top;
    } catch (e) {
      return false;
    }
  }

  public getAcceptedUrlNames(): string[] {
    return this.urlNames || [];
  }

  public emitSaveTokenEvent(token: string): void {
    try {
      const message = JSON.stringify({
        type: IFRAME_EVENT_NAME.SAVE_TOKEN,
        data: token,
      });

      window.parent.postMessage(message, '*');
    } catch (e) {}
  }

  public emitRemoveTokenEvent(): void {
    try {
      const message = JSON.stringify({
        type: IFRAME_EVENT_NAME.REMOVE_TOKEN,
      });

      window.parent.postMessage(message, '*');
    } catch (e) {}
  }

  private emitEnableIframeModeRequiredEvent(): void {
    try {
      const message = JSON.stringify({
        type: IFRAME_EVENT_NAME.ENABLE_IFRAME_MODE_REQUIRED,
      });

      window.parent.postMessage(message, '*');
    } catch (e) {}
  }
}
